import styled from 'styled-components'

export const SearchCreateWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    @media (max-width: 1000px) {
        flex-direction: column;
        align-items: flex-start;
        margin-left: 10px;
    }
`
